<div class="npdc-title">
  <h1>User roles</h1>
  <div class="npdc-title__actions">
    <a mat-flat-button routerLink="new">New user role</a>
  </div>
</div>

<p>A user role grants a group of accounts authorized access to preconfigured endpoints.</p>

<app-list [resource]="roles" [disableClear]="true">
  @if (!roles.error()) {
    <mat-nav-list>
      @for (role of roles.value()?.items; track role.id) {
        <a mat-list-item routerLink="{{ role.id }}/edit">
          <mat-icon matListItemIcon>groups</mat-icon>
          <span matListItemTitle>{{ role.name }}</span>
          <span matListItemLine>
            <span>Created by </span>
            @if (role.createdBy | resolveUser | async; as user) {
              <span>{{ user.email }}</span>
            } @else {
              <span>{{ role.createdBy }}</span>
            }
            <span> on {{ role.created | date }}</span>
          </span>
          <span matListItemLine>
            <span>Modified by </span>
            @if (role.modifiedBy | resolveUser | async; as user) {
              <span>{{ user.email }}</span>
            } @else {
              <span>{{ role.createdBy }}</span>
            }
            <span> on {{ role.created | date }}</span>
          </span>
        </a>
      }
    </mat-nav-list>
  }
</app-list>
